module.exports = __webpack_public_path__ + "assets/webgl/LM_1_2.0a04d0f2.jpg";